import { createContext, useContext } from 'react';

export const DropDownContext = createContext<{ isActive: boolean; setInActive: () => void }>({
  isActive: false,
  setInActive() {},
});

export function useDropDownContext() {
  const context = useContext(DropDownContext);

  if (!context) throw new Error('Dropdown.* can only be used as a direct child of DropDown component');

  return context;
}
